<button mat-icon-button class="close-button" [mat-dialog-close]="true">
  <mat-icon class="close-icon" >close</mat-icon>
</button>

<div class="Dialog-body" *ngIf="isnoData==false">
 
  <div class="modal-header">
    <mat-label class =dashboard-lable> {{IncidentName}}</mat-label>
    <!-- <div class="sc-badge sc-safe" style="padding: 4px 3px !important;">Forms</div> -->
</div>
<div style="width: 100%;">
  <table class="table table--full-width table--striped" style="margin-top: 9px;">
    <thead>
      <tr>
        <th style="display: flex;flex-direction: row;justify-content: space-between;">
          <div style="display: flex;flex: 1;justify-content: center;">
            <span
              style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">Date</span>
          </div>       
          <div style="display: flex;flex: 1;justify-content: center;">
            <span
              style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">Form</span>
          </div>
          <div style="display: flex;flex: 1;justify-content: center;">
            <span
              style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">Related
              User</span>
          </div>
          <div style="display: flex;flex: 1;justify-content: center;">
            <span
              style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">Form
              Type</span>
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let sr of FormList">
        <td style="min-width: 50px;display: flex;flex-direction: row;justify-content: space-between;">

          <div style="display: flex;flex: 1;justify-content: center;">
            <span  (click)="onClickOpenForm(sr)"
              style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{sr.Date}}</span>
          </div>
          
          <div style="display: flex;flex: 1;justify-content: left;">
            <span (click)="onClickOpenForm(sr)"
              style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{sr.FormName}}</span>
          </div>
          <div style="display: flex;flex: 1;justify-content: center;">
            <span (click)="onClickOpenForm(sr)"
              style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{sr.userName}}</span>
          </div>

          <div style="display: flex;flex: 1;justify-content: center;">
            <span
              style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;"
              class="material-icons-outlined">
              <i *ngIf="sr.IsDigitalForm == true" class="material-icons">dynamic_form</i>
              <i (click)="onClickDownloadForm(sr)" *ngIf="sr.IsDigitalForm != true"
                class="material-icons">picture_as_pdf</i>
            </span>
          </div>

        </td>
      </tr>
    </tbody>
  </table>

</div>
<!-- <div class="buttonbelow">
  <button mat-button  (click)="DialogClose()" >Cancel</button>    
</div> -->
</div>
<div style="width: 100%;" *ngIf="isnoData==true">
  <mat-label style="color: red"> {{isnoDataLable}}</mat-label>  
</div>